import { render, staticRenderFns } from "./autolinks.vue?vue&type=template&id=177ebeef"
import script from "./autolinks.vue?vue&type=script&lang=ts"
export * from "./autolinks.vue?vue&type=script&lang=ts"
import style0 from "./autolinks.vue?vue&type=style&index=0&id=177ebeef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports